import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgxMaskDirective } from "ngx-mask";
import { CalendarModule } from "primeng/calendar";
import { DropdownModule } from "primeng/dropdown";
import { FileUploadModule } from "primeng/fileupload";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { PaginatorModule } from "primeng/paginator";
import { SpeedDialModule } from "primeng/speeddial";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { CurrencyMaskDirective } from "../directives/currency-mask/currency-mask.directive";
import { TransitionDirective } from "../directives/transition/transition.directive";
import { PipesModule } from "../pipes/pipes.module";
import { BackButtonComponent } from "./back-button/back-button.component";
import { BudgetMobileCardComponent } from "./budget-mobile-card/budget-mobile-card.component";
import { BudgetSelectionComponent } from "./budget-selection/budget-selection.component";
import { ButtonComponent } from "./button/button.component";
import { ClientFormComponent } from "./client-form/client-form.component";
import { CompanySettingsTabComponent } from "./company-settings-tab/company-settings-tab.component";
import { ContainerComponent } from "./container/container.component";
import { ContentComponent } from "./content/content.component";
import { FieldsComponent } from "./fields/fields.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { InputComponent } from "./input/input.component";
import { ItemCardComponent } from "./item-card/item-card.component";
import { LoadingOverlayComponent } from "./loading-overlay/loading-overlay.component";
import { ModalComponent } from "./modal/modal.component";
import { NcmCardComponent } from "./ncm-card/ncm-card.component";
import { NcmSelectorTabPanelComponent } from "./ncm-selector-tab-panel/ncm-selector-tab-panel.component";
import { NfeCardComponent } from "./nfe-card/nfe-card.component";
import { NfceCardComponent } from "./nfce-card/nfce-card.component";
import { NfeFormComponent } from "./nfe-form/nfe-form.component";
import { NfseCardComponent } from "./nfse-card/nfse-card.component";
import { PaymentCardComponent } from "./payment-card/payment-card.component";
import { PaymentsComponent } from "./payments/payments.component";
import { SectionComponent } from "./section/section.component";
import { SelectComponent } from "./select/select.component";
import { ServiceFormComponent } from "./service-form/service-form.component";
import { ServiceSelectorComponent } from "./service-selector/service-selector.component";
import { SideNavigationComponent } from "./side-navigation/side-navigation.component";
import { SupportButtonComponent } from "./support-button/support-button.component";
import { NfseSettingsTabComponent } from "./nfse-settings-tab/nfse-settings-tab.component";
import { ServiceCardComponent } from "./service-card/service-card.component";
import { ServiceMobileCardComponent } from "./service-mobile-card/service-mobile-card.component";
import { LogoUploadComponent } from "./logo-upload/logo-upload.component";
import { PeriodFilterComponent } from "./period-filter/period-filter.component";
import { ParametrizationIssuesTabComponent } from "./parametrization-issues-tab/parametrization-issues-tab.component";
import { OverlayPanelModule } from "primeng/overlaypanel";
@NgModule({
  declarations: [
    ContainerComponent,
    SideNavigationComponent,
    SupportButtonComponent,
    BackButtonComponent,
    LoadingOverlayComponent,
    CompanySettingsTabComponent,
    ButtonComponent,
    ModalComponent,
    FileUploadComponent,
    ClientFormComponent,
    NfeFormComponent,
    BudgetSelectionComponent,
    ItemCardComponent,
    InputComponent,
    SelectComponent,
    ContentComponent,
    SectionComponent,
    FieldsComponent,
    PaymentsComponent,
    PaymentCardComponent,
    NfeCardComponent,
    NfceCardComponent,
    ServiceSelectorComponent,
    ServiceFormComponent,
    BudgetMobileCardComponent,
    NfseCardComponent,
    NcmSelectorTabPanelComponent,
    NcmCardComponent,
    NfseSettingsTabComponent,
    ServiceCardComponent,
    ServiceMobileCardComponent,
    LogoUploadComponent,
    PeriodFilterComponent,
    ParametrizationIssuesTabComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TransitionDirective,
    CurrencyMaskDirective,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    InputTextModule,
    DropdownModule,
    FileUploadModule,
    PaginatorModule,
    TableModule,
    TooltipModule,
    SpeedDialModule,
    PipesModule,
    MenuModule,
    OverlayPanelModule,
    CalendarModule
  ],
  exports: [
    ContainerComponent,
    SideNavigationComponent,
    SupportButtonComponent,
    BackButtonComponent,
    LoadingOverlayComponent,
    CompanySettingsTabComponent,
    ModalComponent,
    ButtonComponent,
    ClientFormComponent,
    NfeFormComponent,
    BudgetSelectionComponent,
    ItemCardComponent,
    InputComponent,
    SelectComponent,
    ContentComponent,
    SectionComponent,
    FieldsComponent,
    PaymentsComponent,
    NfeCardComponent,
    NfceCardComponent,
    ServiceSelectorComponent,
    ServiceFormComponent,
    NfseCardComponent,
    NcmSelectorTabPanelComponent,
    NfseSettingsTabComponent,
    ServiceCardComponent,
    ServiceMobileCardComponent,
    PeriodFilterComponent,
    ParametrizationIssuesTabComponent
  ]
})
export class ComponentsModule {}
